import { Add } from '@carbon/icons-react';
import { Button } from '@routable/gross-ds';
import React, {} from 'react';
import { TooltipPlacement } from 'constants/tooltip';
import RestrictedPermissionTooltip from 'modules/auth/RestrictedPermissionTooltip';
export const RestrictedAddContactButton = ({ children = 'Contact' }) => (React.createElement(RestrictedPermissionTooltip, { position: TooltipPlacement.LEFT, size: "medium" },
    React.createElement(Button, { "data-testid": "restricted-add--contact-button", disabled: true, variant: "outline" },
        React.createElement(Add, { size: 14 }),
        children)));
